import React from "react";

class QuestionManufactureComponent extends React.Component {
  render() {
    return (
      <span>
        <div className="col s12 l10">
          <h5>{this.props.questionText}</h5>
         

          <div className="following-cities drop_c_width">
            {this.props.QuestionOptions}
            
            {/* {this.props.po} */}
          </div>
          <div className="col s12 l10" style={{marginBottom:"25px"}}>
          <p
            ref={this.props.refd}
            className={
              this.props.questionTypeCheck
                ? "col s12 apply-questionTypeCheck-ShowHide"
                : "col s12 hide"
            }
          >
            Select I Don't Know if you think your purchase was from a listed
            manufacturer but you’re not sure.
          </p>
              </div>
         
          <div className="col s12 l10">
          {this.props.questionLabel}
          </div>
          <div className={this.props.questionLabel ? "outer joc":""}>
          <div className="joc col s12 ">
          {/* {this.props.questionLabel} */}
          </div>
          <div className="col s12 " style={{marginLeft: "30px",paddingTop: "20px"}}>
          {this.props.questionFile}
          </div>
          <div className = "jock col s12 ">
          {/* {this.props.questionName}
          {this.props.questionTable}
          {this.props.questionTables} */}
          <table>
            <tr style={{borderBottom:"0px"}}>
              <td>{this.props.questionName}</td>
              <td> {this.props.questionTable}</td>
              <td>{this.props.questionTables}</td>
            </tr>
          </table>
          </div>
          </div>
          </div>
          
          <div className="col s12 l10" style={{marginLeft:"155px",marginTop:"60px"}}>
          {this.props.questionNotesText}
          </div>
          <div style={{marginLeft:"155px"}}>{this.props.questionInput} </div>
          
          
      </span>
    );
    // return (
    //   <span>
    //     <div className="col s12 l10">
    //       <h5>{this.props.questionText}</h5>
    //       <div className="following-cities drop_c_width">
    //         {this.props.QuestionOptions}
    //       </div>
    //       <p
    //         ref={this.props.refd}
    //         className={
    //           this.props.questionTypeCheck
    //             ? "col s12 apply-questionTypeCheck-ShowHide"
    //             : "col s12 hide"
    //         }
    //       >
    //         Select I Don't Know if you think your purchase was from a listed
    //         manufacturer but you’re not sure.
    //       </p>
    //       <div className="col s12 l10">
    //       {this.props.questionNotesText}
    //       </div>
    //       {this.props.questionInput}
    //       <div className="col s12 l10">
    //       {this.props.questionLabel}
    //       </div>
    //       <div className={this.props.questionLabel ? "outer joc":""}>
    //       <div className="joc col s12 ">
    //       {/* {this.props.questionLabel} */}
    //       </div>
    //       <div className="col s12 " style={{marginLeft: "30px",paddingTop: "20px"}}>
    //       {this.props.questionFile}
    //       </div>
    //       <div className = "jock col s12 ">
    //       {/* {this.props.questionName}
    //       {this.props.questionTable}
    //       {this.props.questionTables} */}
    //       <table>
    //         <tr style={{borderBottom:"0px"}}>
    //           <td>{this.props.questionName}</td>
    //           <td> {this.props.questionTable}</td>
    //           <td>{this.props.questionTables}</td>
    //         </tr>
    //       </table>
    //       </div>
    //       </div>
    //       </div>
    //   </span>
    // );
  }
}
export default QuestionManufactureComponent;
